import { Alert, Typography } from '@mui/material';
import moment from 'moment/moment';
import * as React from 'react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type PropsType = {
  enabled: boolean;
  startDate?: Date | null;
  endDate?: Date | null;
};

export const BackDatingNotification = (props: PropsType) => {
  const { enabled, endDate, startDate } = props;
  const { t } = useTranslation();

  const isBackdated = useCallback((date?: Date | null) => {
    return moment(date).isBefore(moment().startOf('day'));
  }, []);

  const { isVisible, isEndDateWarning } = useMemo(() => {
    const dateWarning = {
      isEndDateWarning: isBackdated(endDate),
      isStartDateWarning: isBackdated(startDate),
    };

    return {
      ...dateWarning,
      isVisible:
        (dateWarning.isEndDateWarning || dateWarning.isStartDateWarning) &&
        enabled,
    };
  }, [enabled, endDate, startDate, isBackdated]);

  return isVisible ? (
    <Alert severity={'info'}>
      <Typography>
        {isEndDateWarning
          ? t('laBackdatingWarningMsgIntro2')
          : t('laBackdatingWarningMsgIntro')}
      </Typography>
      <ul>
        <li>{t('laBackdatingWarningMsg1')}</li>
        <li>{t('laBackdatingWarningMsg2')}</li>
        <li>{t('laBackdatingWarningMsg3')}</li>
      </ul>
    </Alert>
  ) : (
    <></>
  );
};
